import { Tooltip } from 'antd';
import { cloneDeep, isEmpty, startCase } from 'lodash';
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

import Input from "../../../../components/uiComponent/inputs/input/index"
import ReactSelect from '../../../../components/uiComponent/select';
import FileUpload from '../../../../components/uiComponent/upload/uploadNew';
import Button from "../../../../components/uiComponent/button/index";

import ErrorIcon from "../../../../assets/icons/error-red.svg"
import PartyIcon from "../../../../assets/icons/party-popper-icon.svg"

import { StepDataWrapper } from '../style'

const StepsData = ({
  sampleFileLink = '',
  currentStep,
  fileData,
  setFileData,
  vendorName = '',
  fileList,
  setFileList,
  setDataToProceed,
  setFileColumns,
  uploadedFiles,
  setFileRows,
  dataToProceed,
  fileColumns,
  fileRows,
  poName,
  setPoName,
  setVendorName,
  vendorsList,
  uploadAddProduct = '',
  setAddProduct = '',
  clearStates,
  editPoItems,
  uploadMapping,
  addProductFile
}) => {
  const { rows } = fileData || {};
  const [selectedOptions, setSelectedOptions] = useState(null);

  const {
    pos,
  } = useSelector((state) => state.pos || {});

  const selectHandleChange = (selected) => {
    setSelectedOptions(selected);
  };

  const [data, setData] = useState([
    {
      label: "Identifier Type",
      important: true,
      optional: false,
      options: [
        { label: "Identifier Typee here", value: "Identifier Typee here" },
        { label: "Identifier Type here", value: "Identifier Type here" },
      ],
      identifiers: [],
    },
    {
      label: "Identifier",
      important: true,
      optional: false,
      options: [
        { label: "Identifier Typee here", value: "Identifier Typee here" },
        { label: "Identifier Type here", value: "Identifier Type here" },
      ],
      identifiers: [],
    },
    {
      label: "Unit Cost",
      important: true,
      optional: false,
      options: [
        { label: "$100", value: "$100" },
        { label: "$1000", value: "$1000" },
      ],
      identifiers: [],
    },
    {
      label: "Order Quantity",
      important: true,
      optional: false,
      options: [
        { label: "100", value: "100" },
        { label: "1000", value: "1000" },
      ],
      identifiers: [],
    },
    {
      label: "Case Qty",
      important: false,
      optional: true,
      options: [
        { label: "Case Quantity heree", value: "Case Quantity heree" },
        { label: "Case Quantity here", value: "Case Quantity here" },
      ],
      identifiers: [],
    },
    {
      label: "Notes",
      important: false,
      optional: true,
      options: [
        { label: "Notes Type heree", value: "Notes Type heree" },
        { label: "Notes Type here", value: "Notes Type here" },
      ],
      identifiers: [],
    },
  ]);

  const [selectUploadMapping, setSelectUploadMapping] = useState([
    {
      label: "Identifier Type",
      important: true,
      optional: false,
      options: [
        { label: "Identifier Typee here", value: "Identifier Typee here" },
        { label: "Identifier Type here", value: "Identifier Type here" },
      ],
      identifiers: [],
    },
    {
      label: "SKU",
      important: true,
      optional: false,
      options: [
        { label: "Identifier Typee here", value: "Identifier Typee here" },
        { label: "Identifier Type here", value: "Identifier Type here" },
      ],
      identifiers: [],
    },
    {
      label: "Bundle qty",
      important: true,
      optional: false,
      options: [
        { label: "$100", value: "$100" },
        { label: "$1000", value: "$1000" },
      ],
      identifiers: [],
    },
  ]);

  const handleChange = (selectedOption, index) => {
    if (!selectedOption) return;
    setData((prevData) =>
      prevData.map((item, idx) =>
        idx === index
          ? {
            ...item,
            identifiers: [...item.identifiers, selectedOption.value],
          }
          : item
      )
    );
  };

  const handleChangeUploadBulk = (selectedOption, index) => {
    if (!selectedOption) return;
    setSelectUploadMapping((prevData) =>
      prevData.map((item, idx) =>
        idx === index
          ? {
            ...item,
            identifiers: [...item.identifiers, selectedOption.value],
          }
          : item
      )
    );
  };

  const handleFileValueChange = (event, label) => {
    const mapping = cloneDeep(dataToProceed);
    const alreadyIndex = mapping.findIndex(val => val.value === event);
    if (alreadyIndex !== -1) mapping[alreadyIndex] = { ...mapping[alreadyIndex], value: '', data: [] };
    const data = rows.map(item => item[event]);
    const index = mapping.findIndex(col => col.label === label);
    mapping[index] = { ...mapping[index], value: event, data };
    setDataToProceed(mapping);
  };

  useEffect(() => {
    if (!isEmpty(dataToProceed)) {
      const dataLength = dataToProceed[0].data.length;
      const originalData = Array.from({ length: dataLength }, (_, index) => {
        const obj = {};
        dataToProceed.forEach(item => {
          obj[item.label] = item.data[index];
        });
        return obj;
      });
      setFileRows(originalData);
    }
  }, [dataToProceed]);

  return (
    <StepDataWrapper>
      {currentStep === 3 ? null :
        (uploadAddProduct || editPoItems || uploadMapping || addProductFile) ?
          <div className='box-wrapper'>
            <header>
              <h6>{currentStep === 2 ? 'Review Errors' : 'PO Information'}</h6>
            </header>
            <div className='body-wrapper'>
              {currentStep === 0 ?
                <FileUpload
                  sampleFileLink={editPoItems ? '' : sampleFileLink}
                  fileList={fileList}
                  setFileData={setFileData}
                  setFileList={setFileList}
                  setDataToProceed={setDataToProceed}
                  setFileColumns={setFileColumns}
                  uploadedFiles={uploadedFiles}
                  setFileRows={setFileRows}
                />
                :
                currentStep === 1 ?
                  <div className="box-items-wrapper">
                    {dataToProceed?.map((item, index) => {
                      const { data = [], value, label, important, optional } = item;
                      return (
                        <div key={index} className="items">
                          <ReactSelect
                            // value={value}
                            label={label ? startCase(label) : label}
                            options={fileColumns}
                            placeholder={label || 'Don’t Import'}
                            className="add-product-manual-wrapper"
                            isClearable
                            important={important}
                            optional={optional}
                            onChange={(selectedOption) => {
                              if (uploadMapping || addProductFile) {
                                handleFileValueChange(selectedOption?.value, label)
                              }
                              handleChangeUploadBulk(selectedOption, index)
                            }
                            }
                          />
                          <div className="value">
                            {/* {uploadAddProduct && identifiers?.map?.((identifier, idIndex) => (
                            <p key={idIndex}>{identifier}</p>
                          ))} */}
                            {(editPoItems || uploadMapping || addProductFile) && data?.slice(0, 3)?.map((identifier, idIndex) => (
                              <p key={idIndex}>{identifier}</p>
                            ))}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  : currentStep === 2 ?
                    <div className='box-container'>
                      <div className='header-ui-wrapper'>
                        <span>Row #</span>
                        {
                          (editPoItems || uploadMapping || addProductFile) ?
                            <>
                              {
                                addProductFile &&
                                <span>Identifier Type</span>
                              }
                              <span>{(editPoItems && !addProductFile) ? 'Identifier Value' : 'Identifier'}</span>
                              {uploadMapping ? <span>SKU</span> : null}
                            </> : null
                        }
                        <span>Error Message</span>
                      </div>
                      <div className='scroll-able-content new-content'>
                        {fileRows.filter((row) => row.reason).length === 0 ? (
                          <div className="no-errors-message">
                            <p>No Error Found!.</p>
                          </div>
                        ) :
                          (fileRows
                            .filter((row) => row.reason)
                            .map((item, index) => (
                              <div key={index} className='body-boxes new-content'>
                                {(editPoItems || uploadMapping || addProductFile) ?
                                  <>
                                    <span>{index + 1 || 'N/A'}</span>
                                    {
                                      addProductFile &&
                                      <span>{item['Identifier Type']?.toUpperCase() || '-'}</span>
                                    }
                                    <span>{item[editPoItems ? 'identifier_value' : 'Identifier'] || '-'}</span>
                                    {uploadMapping ? <span>{item['Sku'] || '-'}</span> : null}
                                    <Tooltip
                                      title={item?.reason || '-'}
                                    >
                                      <span className="error-message">
                                        <img src={ErrorIcon} alt="Error" /> {item.reason}
                                      </span>
                                    </Tooltip>
                                  </> :
                                  <>
                                    <span>{item.row}</span>
                                    <span>{item.sku}</span>
                                    <span><img src={ErrorIcon} /> {item.error}</span>
                                  </>
                                }
                              </div>
                            )))}
                      </div>
                    </div>
                    : null}
            </div>
          </div>
          :
          <div className='box-wrapper'>
            <header>
              <h6>{currentStep === 2 ? 'Review Errors' : 'PO Information'}</h6>
            </header>
            <div className='body-wrapper'>
              {currentStep === 0 ? <>
                <div className='form-wrapper'>
                  <Input
                    className="inputs"
                    important
                    placeholder="Enter"
                    label="PO Name"
                    value={poName}
                    onChange={(e) => setPoName(e.target.value)}
                  />
                  <ReactSelect
                    label="Vendor Name"
                    options={vendorsList}
                    value={vendorsList.find((vendor) => vendor.value === vendorName) || null}
                    placeholder="Select Vendor"
                    className="add-product-manual-wrapper"
                    isClearable
                    important
                    isMulti={false}
                    maxHeight={200}
                    onChange={(e) => {
                      const vendorName = e?.value;

                      let poName = '';
                      if (vendorName) {
                        poName = `${vendorName}-${dayjs().format('DD-MM-YYYY')}`;
                        const matchedEntries = pos.filter(({ file_name }) => file_name.includes(poName));
                        poName += `-${(matchedEntries?.length || 0) + 1}`;
                      }
                      setVendorName(vendorName);
                      setPoName(poName);
                    }}
                  />
                </div>
                <FileUpload
                  sampleFileLink={sampleFileLink}
                  fileList={fileList}
                  setFileData={setFileData}
                  setFileList={setFileList}
                  setDataToProceed={setDataToProceed}
                  setFileColumns={setFileColumns}
                  uploadedFiles={uploadedFiles}
                  setFileRows={setFileRows}
                />
              </> :
                currentStep === 1 ?
                  <div className="box-items-wrapper">
                    {dataToProceed.map((item, index) => {
                      const { data = [], value, label, important, optional } = item;
                      return (
                        <div key={index} className="items">
                          <ReactSelect
                            value={value}
                            label={label}
                            options={fileColumns}
                            placeholder={label || 'Don’t Import'}
                            className="add-product-manual-wrapper"
                            isClearable
                            important={important}
                            optional={optional}
                            onChange={(selectedOption) =>
                              handleFileValueChange(selectedOption.value, label)
                            }
                          />
                          <div className="value">
                            {data?.slice(0, 3)?.map((identifier, idIndex) => (
                              <p key={idIndex}>{identifier}</p>
                            ))}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  : currentStep === 2 ?
                    <div className="box-container">
                      <div className="header-ui-wrapper">
                        <span>Row #</span>
                        <span>Identifier Type</span>
                        <span>Identifier Value</span>
                        <span>Error Message</span>
                      </div>
                      <div className="scroll-able-content">
                        {fileRows.filter((row) => row.reason).length === 0 ? (
                          <div className="no-errors-message">
                            <p>No Error Found!.</p>
                          </div>
                        ) : (
                          fileRows
                            .filter((row) => row.reason)
                            .map((item, index) => (
                              <div key={index} className="body-boxes">
                                <span>{index + 1 || 'N/A'}</span>
                                <span>{item['Identifier Type']?.toUpperCase() || '-'}</span>
                                <span>{item['Identifier'] || '-'}</span>
                                <Tooltip
                                  title={item?.reason || '-'}
                                >
                                  <span className="error-message">
                                    <img src={ErrorIcon} alt="Error" /> {item.reason}
                                  </span>
                                </Tooltip>
                              </div>
                            ))
                        )}
                      </div>
                    </div>
                    : null}
            </div>
          </div>
      }
      {currentStep === 3 ? (
        <div className="congratulations-wrapper">
          <img src={PartyIcon} title={PartyIcon} alt={PartyIcon} />
          <h1>File Uploaded Successfully</h1>
          <p>Your PO file is successfully uploaded.</p>
          <Button onClick={() => clearStates()} text="Go to PO Page" />
        </div>
      ) : null}
    </StepDataWrapper>
  )
}

export default StepsData;
